export function NotFoundPage() {
  return (
    <main className="shell">
      <h1>Page not found</h1>
      <p>
        <a href="/">Start a consult with Otto</a>
      </p>
    </main>
  );
}
